module.exports = __webpack_public_path__ + "static/media/accepted_pass.a6ec5a13.svg";